import { webConstants } from "@payping/utils/platformConstants";

const { requestMoney, product, ipg, invoice, customer, user } = webConstants.DashboardRoutes;

export interface FAQType {
  translationKey: string;
  url: string[];
}

/* eslint-disable sort-keys */
export const FAQ: FAQType[] = [
  { translationKey: "plugins", url: [ipg.service.root] },
  { translationKey: "telegram", url: [ipg.service.root] },
  { translationKey: "kaveNegar", url: [ipg.service.root] },
  { translationKey: "slack", url: [ipg.service.root] },
  { translationKey: "mailerLite", url: [ipg.service.root] },
  { translationKey: "bidok", url: [ipg.service.root] },
  { translationKey: "wooCommerce", url: [ipg.service.root] },

  { translationKey: "customer", url: [customer.root] },

  { translationKey: "invoice", url: [invoice.root] },
  { translationKey: "savePayment", url: [invoice.root] },
  { translationKey: "moreInvoice", url: [invoice.root] },
  { translationKey: "invoiceCluster", url: [invoice.root] },
  { translationKey: "invoiceDifference", url: [invoice.root] },
  { translationKey: "receiveInvoice", url: [invoice.root] },

  { translationKey: "changeUsername", url: [user.root] },
  { translationKey: "changeEmail", url: [user.root] },
  { translationKey: "payPingPricing", url: [user.root] },
  { translationKey: "howToSettle", url: [user.root] },
  { translationKey: "referral1", url: [user.referral] },
  { translationKey: "referral2", url: [user.referral] },
  { translationKey: "referral3", url: [user.referral] },

  { translationKey: "whatIsItem", url: [product.root] },
  { translationKey: "itemCRUD", url: [product.root] },
  { translationKey: "itemArchive", url: [product.root] },
  { translationKey: "directPaymentLink", url: [product.root] },
  { translationKey: "callbackPage", url: [product.root] },
  { translationKey: "sendMessageOrEmail", url: [product.root] },

  { translationKey: "couponUsage", url: [invoice.root, product.root] },
  { translationKey: "couponCreate", url: [invoice.root, product.root] },

  // { translationKey: "reports", url: [report.root] },
  // { translationKey: "reportSettle", url: [report.root] },

  { translationKey: "requestMoney", url: [requestMoney.root] },
];
/* eslint-enable sort-keys */
